import { navigate } from "gatsby";
import queryString from "query-string";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React, { useState } from "react";

import Radio from "~/components/FormElements/Radio";
import SearchInput from "~/components/FormElements/SearchInput";

import { ColumnTitle, Copy, Text } from "~/components/Footer/Expert";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

import { useLocationContext } from "~/context/LocationContext";

const RadioWrapper = styled.div`
    margin-bottom: 5px;
`;

const WhereToBuy = ({
    title = "",
    copy = "",
    searchOptions = [],
    searchPlaceholder = "",
    shopText = "",
}) => {
    const [searchValues, setSearchValues] = useState({
        searchTextWTB: "",
        searchTypeWTB: searchOptions[0]?.value || "",
    });

    const { location } = useLocationContext();

    const createNewUrl = (typePath, addressQuery) => {
        const params = queryString.parse(location.search);
        const queryParams = { ...params, ...addressQuery };

        return `/where-to-buy/${typePath}/?${queryString.stringify(
            queryParams,
            {
                skipNull: true,
            },
        )}`;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setSearchValues({
            ...searchValues,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        navigate(
            createNewUrl(searchValues.searchTypeWTB, {
                address: searchValues.searchTextWTB,
            }),
        );
    };

    return (
        <>
            {title ? <ColumnTitle>{title}</ColumnTitle> : null}

            {copy ? <Copy>{copy}</Copy> : null}

            <form onSubmit={handleSubmit}>
                {searchOptions?.length ? (
                    <RadioWrapper>
                        <Radio
                            {...{ handleChange }}
                            label="Select your search options"
                            labelPlacement="hidden_label"
                            textColor="white"
                            name="searchTypeWTB"
                            options={searchOptions.map(({ text, value }) => ({
                                text: text,
                                value: value,
                            }))}
                            value={searchValues.searchTypeWTB}
                        />
                    </RadioWrapper>
                ) : null}

                <SearchInput
                    placeholder={searchPlaceholder}
                    icon="search"
                    name="searchTextWTB"
                    type="text"
                    buttonScreenReaderText="Click to search"
                    borderColor="white"
                    onChange={handleChange}
                    value={searchValues.searchTextWTB}
                    id="where-to-buy-search"
                    label="Where To Buy Search"
                />
            </form>

            {shopText ? <Text>{sanitizeAndParseHTML(shopText)}</Text> : null}
        </>
    );
};

WhereToBuy.propTypes = {
    title: PropTypes.string,
    copy: PropTypes.string,
    searchOptions: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
    ),
    searchPlaceholder: PropTypes.string,
    shopText: PropTypes.string,
};

export default WhereToBuy;
